
/**
 * Bulletproof HTML email templates
 * These templates are pre-compiled from MJML for maximum compatibility across email clients
 */

export const userRegistrationTemplate = `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
  <title>Üdvözöljük a MediHub rendszerében!</title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table,
    td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
        <noscript>
        <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG/>
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
        </xml>
        </noscript>
        <![endif]-->
  <!--[if lte mso 11]>
        <style type="text/css">
          .mj-outlook-group-fix { width:100% !important; }
        </style>
        <![endif]-->
  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }
  </style>
  <style type="text/css">
    @media only screen and (max-width:480px) {
      table.mj-full-width-mobile {
        width: 100% !important;
      }

      td.mj-full-width-mobile {
        width: auto !important;
      }
    }
  </style>
  <style type="text/css">
    .link-nostyle {
      color: #333333;
      text-decoration: none
    }

    .footer-link {
      color: #666666;
      text-decoration: underline
    }
  </style>
</head>

<body style="word-spacing:normal;background-color:#F5F5F5;">
  <div style="background-color:#F5F5F5;">
    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#F5F5F5" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:180px;">
                                <img height="auto" src="https://your-domain.com/lovable-uploads/db09ebb2-f226-42c3-b10b-7271f8c50447.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="180" alt="MediHub Logo" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;border-radius:4px;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;border-radius:4px;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:40px 20px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:560px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:22px;font-weight:700;line-height:1;text-align:center;color:#FE5757;">Üdvözöljük a MediHub rendszerében!</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Kedves {{name}},</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Köszönjük, hogy regisztrált a MediHub orvosi eseménykezelő platformunkra. Mielőtt elkezdené használni a szolgáltatásainkat, kérjük, erősítse meg e-mail címét az alábbi gombra kattintva:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:20px 0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tr>
                            <td align="center" bgcolor="#FE5757" role="presentation" style="border:none;border-radius:4px;cursor:auto;mso-padding-alt:10px 25px;background:#FE5757;" valign="middle">
                              <a href="{{verificationLink}}" style="display:inline-block;background:#FE5757;color:#ffffff;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:600;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:4px;" target="_blank"> Email cím megerősítése </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:400;line-height:24px;text-align:left;color:#666666;">A megerősítő link 24 óráig érvényes. Ha a gomb nem működik, másolja és illessze be az alábbi URL-t a böngészőjébe:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:monospace, serif;font-size:14px;font-weight:400;line-height:24px;text-align:left;color:#666666;"><a href="{{verificationLink}}" style="color: #666666; word-break: break-all;">{{verificationLink}}</a></div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">A MediHub segítségével:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">• Könnyedén megtalálhatja a releváns orvosi eseményeket<br />• Kezelheti a jelentkezéseit és a naptárát<br />• Nyomon követheti a továbbképzési pontjait<br />• Személyre szabott ajánlatokat kaphat az Önt érdeklő témákban</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Ha bármilyen kérdése van, forduljon bizalommal ügyfélszolgálatunkhoz a support@medihub.hu e-mail címen.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:20px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Üdvözlettel,<br />A MediHub Csapata</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">© 2023 MediHub. Minden jog fenntartva.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;"><a href="{{privacyPolicyUrl}}" class="footer-link">Adatvédelmi szabályzat</a> • <a href="{{termsUrl}}" class="footer-link">Felhasználási feltételek</a></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">Ha nem szeretne több értesítést kapni, <a href="{{unsubscribeUrl}}" class="footer-link">iratkozzon le itt</a>.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">MediHub Kft., 1051 Budapest, Példa utca 1.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><![endif]-->
  </div>
</body>

</html>`;

export const passwordResetTemplate = `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
  <title>Jelszó visszaállítás - MediHub</title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table,
    td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
        <noscript>
        <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG/>
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
        </xml>
        </noscript>
        <![endif]-->
  <!--[if lte mso 11]>
        <style type="text/css">
          .mj-outlook-group-fix { width:100% !important; }
        </style>
        <![endif]-->
  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }
  </style>
  <style type="text/css">
    @media only screen and (max-width:480px) {
      table.mj-full-width-mobile {
        width: 100% !important;
      }

      td.mj-full-width-mobile {
        width: auto !important;
      }
    }
  </style>
  <style type="text/css">
    .footer-link {
      color: #666666;
      text-decoration: underline
    }
  </style>
</head>

<body style="word-spacing:normal;background-color:#F5F5F5;">
  <div style="background-color:#F5F5F5;">
    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#F5F5F5" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:180px;">
                                <img height="auto" src="https://your-domain.com/lovable-uploads/db09ebb2-f226-42c3-b10b-7271f8c50447.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="180" alt="MediHub Logo" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;border-radius:4px;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;border-radius:4px;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:40px 20px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:560px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:22px;font-weight:700;line-height:1;text-align:center;color:#FE5757;">Jelszó visszaállítás</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Kedves {{name}},</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Megkaptuk jelszó visszaállítási kérelmét a MediHub fiókjához. A jelszó visszaállításához kattintson az alábbi gombra:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:20px 0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tr>
                            <td align="center" bgcolor="#FE5757" role="presentation" style="border:none;border-radius:4px;cursor:auto;mso-padding-alt:10px 25px;background:#FE5757;" valign="middle">
                              <a href="{{resetLink}}" style="display:inline-block;background:#FE5757;color:#ffffff;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:600;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:4px;" target="_blank"> Jelszó visszaállítása </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:400;line-height:24px;text-align:left;color:#666666;">A visszaállítási link 24 óráig érvényes. Ha a gomb nem működik, másolja és illessze be az alábbi URL-t a böngészőjébe:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:monospace, serif;font-size:14px;font-weight:400;line-height:24px;text-align:left;color:#666666;"><a href="{{resetLink}}" style="color: #666666; word-break: break-all;">{{resetLink}}</a></div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Ha nem Ön kérte a jelszó visszaállítását, kérjük, hagyja figyelmen kívül ezt az e-mailt, vagy lépjen kapcsolatba ügyfélszolgálatunkkal a support@medihub.hu e-mail címen.</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Biztonsági tippek:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">• Használjon legalább 8 karakterből álló, betűket, számokat és különleges karaktereket tartalmazó jelszót<br />• Ne használja ugyanazt a jelszót több webhelyen<br />• Rendszeresen változtassa meg jelszavát a fokozott biztonság érdekében</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:20px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Üdvözlettel,<br />A MediHub Csapata</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">© 2023 MediHub. Minden jog fenntartva.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;"><a href="{{privacyPolicyUrl}}" class="footer-link">Adatvédelmi szabályzat</a> • <a href="{{termsUrl}}" class="footer-link">Felhasználási feltételek</a></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">MediHub Kft., 1051 Budapest, Példa utca 1.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><![endif]-->
  </div>
</body>

</html>`;

export const notificationTemplate = `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
  <title>Új események a MediHub-on</title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table,
    td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
        <noscript>
        <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG/>
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
        </xml>
        </noscript>
        <![endif]-->
  <!--[if lte mso 11]>
        <style type="text/css">
          .mj-outlook-group-fix { width:100% !important; }
        </style>
        <![endif]-->
  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }
  </style>
  <style type="text/css">
    @media only screen and (max-width:480px) {
      table.mj-full-width-mobile {
        width: 100% !important;
      }

      td.mj-full-width-mobile {
        width: auto !important;
      }
    }
  </style>
  <style type="text/css">
    .footer-link {
      color: #666666;
      text-decoration: underline
    }
    .event-card {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      margin-bottom: 16px;
    }
    .event-title {
      color: #FE5757;
      font-weight: bold;
    }
    .event-date {
      color: #374151;
      font-size: 14px;
    }
    .event-location {
      color: #6B7280;
      font-size: 14px;
    }
    .recommended-badge {
      background-color: #FECACA;
      color: #991B1B;
      font-size: 12px;
      border-radius: 4px;
      padding: 2px 8px;
      font-weight: bold;
    }
  </style>
</head>

<body style="word-spacing:normal;background-color:#F5F5F5;">
  <div style="background-color:#F5F5F5;">
    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#F5F5F5" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:180px;">
                                <img height="auto" src="https://your-domain.com/lovable-uploads/db09ebb2-f226-42c3-b10b-7271f8c50447.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="180" alt="MediHub Logo" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;border-radius:4px;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;border-radius:4px;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:40px 20px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:560px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:22px;font-weight:700;line-height:1;text-align:center;color:#FE5757;">Új események a MediHub-on</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Kedves {{name}},</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Az alábbi események érhetők el a héten, amelyek érdekelhetnek a preferenciáid alapján:</div>
                      </td>
                    </tr>
                    
                    <!-- Event list will be generated here -->
                    {{eventList}}
                    
                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:20px 0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tr>
                            <td align="center" bgcolor="#FE5757" role="presentation" style="border:none;border-radius:4px;cursor:auto;mso-padding-alt:10px 25px;background:#FE5757;" valign="middle">
                              <a href="https://medihub.hu/events" style="display:inline-block;background:#FE5757;color:#ffffff;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:600;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:4px;" target="_blank"> További eseményeink megtekintése </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:20px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Üdvözlettel,<br />A MediHub Csapata</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">© 2023 MediHub. Minden jog fenntartva.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;"><a href="{{privacyPolicyUrl}}" class="footer-link">Adatvédelmi szabályzat</a> • <a href="{{termsUrl}}" class="footer-link">Felhasználási feltételek</a></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">Ha nem szeretne több értesítést kapni, <a href="{{unsubscribeUrl}}" class="footer-link">iratkozzon le itt</a>.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">MediHub Kft., 1051 Budapest, Példa utca 1.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0px;word-break:break-word;">
                        <img src="{{trackingPixel}}" width="1" height="1" style="display:block;outline:none;border:none;text-decoration:none" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><![endif]-->
  </div>
</body>

</html>`;

export const reportSendingTemplate = `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
  <title>Esemény jelentés - MediHub</title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table,
    td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
        <noscript>
        <xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG/>
          <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
        </xml>
        </noscript>
        <![endif]-->
  <!--[if lte mso 11]>
        <style type="text/css">
          .mj-outlook-group-fix { width:100% !important; }
        </style>
        <![endif]-->
  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }
  </style>
  <style type="text/css">
    @media only screen and (max-width:480px) {
      table.mj-full-width-mobile {
        width: 100% !important;
      }

      td.mj-full-width-mobile {
        width: auto !important;
      }
    }
  </style>
  <style type="text/css">
    .footer-link {
      color: #666666;
      text-decoration: underline
    }

    .report-stats {
      border-bottom: 1px solid #E5E7EB;
      padding-bottom: 12px;
      margin-bottom: 12px;
    }
  </style>
</head>

<body style="word-spacing:normal;background-color:#F5F5F5;">
  <div style="background-color:#F5F5F5;">
    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#F5F5F5" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:180px;">
                                <img height="auto" src="https://your-domain.com/lovable-uploads/db09ebb2-f226-42c3-b10b-7271f8c50447.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="180" alt="MediHub Logo" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;border-radius:4px;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;border-radius:4px;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:40px 20px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:560px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:22px;font-weight:700;line-height:1;text-align:center;color:#FE5757;">Esemény jelentés</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Kedves {{name}},</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Mellékelten küldjük a kért jelentést a(z) "{{eventName}}" eseményről. Az alábbi linkre kattintva megtekintheti és letöltheti a teljes jelentést:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:20px 0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tr>
                            <td align="center" bgcolor="#FE5757" role="presentation" style="border:none;border-radius:4px;cursor:auto;mso-padding-alt:10px 25px;background:#FE5757;" valign="middle">
                              <a href="{{reportLink}}" style="display:inline-block;background:#FE5757;color:#ffffff;font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:600;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;mso-padding-alt:0px;border-radius:4px;" target="_blank"> Jelentés megtekintése </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:600;line-height:24px;text-align:left;color:#333333;">Jelentés összefoglaló:</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="background:#F5F5F5;border-radius:4px;font-size:0px;padding:16px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:14px;line-height:24px;text-align:left;color:#333333;"><strong>Esemény neve:</strong> {{eventName}}<br /><br /><strong>Időpont:</strong> {{eventDate}}<br /><br /><strong>Helyszín:</strong> {{eventVenue}}<br /><br /><strong>Résztvevők száma:</strong> {{participantCount}}<br /><br /><strong>Esemény megtekintések:</strong> {{viewCount}}<br /><br /><strong>Átkattintási arány:</strong> {{clickThroughRate}}%</div>
                      </td>
                    </tr>
                    <tr>
                      <td style="font-size:0px;word-break:break-word;">
                        <div style="height:20px;line-height:20px;">&#8202;</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">A teljes jelentés tartalmazza az összes részletet, beleértve a résztvevői visszajelzéseket, demográfiai adatokat és az esemény pénzügyi kimutatását.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:10px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Ha kérdése van a jelentéssel kapcsolatban, vagy további információra van szüksége, kérjük, lépjen kapcsolatba ügyfélszolgálatunkkal a support@medihub.hu e-mail címen.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:20px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#333333;">Üdvözlettel,<br />A MediHub Csapata</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">© 2023 MediHub. Minden jog fenntartva.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;"><a href="{{privacyPolicyUrl}}" class="footer-link">Adatvédelmi szabályzat</a> • <a href="{{termsUrl}}" class="footer-link">Felhasználási feltételek</a></div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">Ha nem szeretne több értesítést kapni, <a href="{{unsubscribeUrl}}" class="footer-link">iratkozzon le itt</a>.</div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:8px 0px 0px;word-break:break-word;">
                        <div style="font-family:Arial, Helvetica, sans-serif;font-size:12px;font-weight:400;line-height:24px;text-align:center;color:#666666;">MediHub Kft., 1051 Budapest, Példa utca 1.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><![endif]-->
  </div>
</body>

</html>`;

/**
 * Create Event Card HTML for notification emails
 * @param event - Event data
 * @param isRecommended - Whether the event is recommended
 * @returns HTML string
 */
export const createEventCard = (
  eventName: string, 
  eventType: string,
  eventDate: string,
  eventLocation: string,
  eventLink: string,
  isRecommended: boolean = false
): string => {
  const recommendedBadge = isRecommended 
    ? `<span style="background-color:#FECACA;color:#991B1B;font-size:12px;border-radius:4px;padding:2px 8px;font-weight:bold;display:inline-block;margin-bottom:8px;">AJÁNLOTT</span><br/>` 
    : '';
    
  return `
  <tr>
    <td style="padding:0px 25px;">
      <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e5e7eb;border-radius:8px;margin-bottom:16px;padding:16px;">
        <tr>
          <td>
            ${recommendedBadge}
            <div style="color:#FE5757;font-weight:bold;font-size:16px;margin-bottom:8px;">${eventName}</div>
            <div style="color:#374151;font-size:14px;margin-bottom:4px;">${eventType}</div>
            <div style="color:#374151;font-size:14px;margin-bottom:4px;">${eventDate}</div>
            <div style="color:#6B7280;font-size:14px;margin-bottom:12px;">${eventLocation}</div>
            <a href="${eventLink}" style="color:#FE5757;font-size:14px;text-decoration:underline;display:inline-block;">Részletek megtekintése</a>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  `;
};

/**
 * Generate event list HTML for notification emails
 * @param events - Regular events
 * @param recommendedEvents - Recommended events
 * @returns HTML string with event cards
 */
export const generateEventListHtml = (
  events: Array<{name: string, type: string, date: string, location: string, link: string}>,
  recommendedEvents: Array<{name: string, type: string, date: string, location: string, link: string}> = []
): string => {
  let eventsHtml = '';
  
  // Add regular events
  events.forEach(event => {
    eventsHtml += createEventCard(
      event.name,
      event.type,
      event.date,
      event.location,
      event.link,
      false
    );
  });
  
  // Add recommended events
  recommendedEvents.forEach(event => {
    eventsHtml += createEventCard(
      event.name,
      event.type,
      event.date,
      event.location,
      event.link,
      true
    );
  });
  
  return eventsHtml;
};

